// import {DateEditor, Decorators, PropertyDialog} from "@serenity-is/corelib";
// import {ImportPrForm} from "@/ServerTypes/WebSupport/Modules.SalesOperation.DistributePr.ImportPrForm";
// import {CsiService} from "@/ServerTypes/Csi/CsiService";
// import ImportPrTemplate = CsiService.ImportPrTemplate;
// import { addDateProxyInput, updateDateProxyValue } from "@idevs/corelib";
// import {Authorization, findElementWithRelativeId} from "@serenity-is/corelib/q";

// import { addDateProxyInput, updateDateProxyValue } from "@idevs/corelib";

// import username = Authorization.username;
namespace GeniuzPOS.Purchase {
    // import ImportPrTemplate = Common.Endpoints.ImportPrTemplate;
@Serenity.Decorators.registerClass('GeniuzPOS.Purchase.ImportPrDialog')
export class ImportPrDialog extends Serenity.PropertyDialog<any, any> {
    protected getFormKey() {return "Purchase.ImportPrForm"; }
    protected getService() { return Common.CsiService.baseUrl; }

    protected form = new ImportPrForm(this.idPrefix);

    public importState: () => void

    constructor() {
        super();

        this.dialogTitle = "Import From Excel";

        const dateDiv = document.querySelector(`.Date`)
        let label = dateDiv.querySelector('label')
        let title = label.getAttribute('title')
        label.innerHTML = `<sup title="this field is required">*</sup>${title}`

        const fileDiv = document.querySelector(`.FileName`)
        label = fileDiv.querySelector('label')
        title = label.getAttribute('title')
        label.innerHTML = `<sup title="this field is required">*</sup>${title}`

        
        
        // addDateProxyInput({name: "Date"});
        // this.form.Date.change((e) => {
        //     let editor = Q.findElementWithRelativeId(this.element, "Date").tryGetWidget(Serenity.DateEditor);
        //     updateDateProxyValue("Date", editor.valueAsDate)
        // });
    }

    protected okClickValidated() {
        if (!this.form.Date.value || !this.form.FileName.value)
        {
            return
        }
        if (!this.form.FileName.value.Filename.includes(`.xls`)) {
            return
        }
        super.okClickValidated();
    }

    protected onDialogClose() {
        super.onDialogClose();

        const date = this.form.Date.value
        const file = this.form.FileName.value
        if (!date || !file) {
            return
        }
        // Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
        Common.CsiService.ImportPrTemplate
        ({
            Date: date,
            FileName: file.Filename,
            OriginalName: file.OriginalName,
            Username: Authorization.userDefinition.Username
        }, (response) => {
            this.importState()
        })
    }

    protected getDialogOptions() {
        const opt = super.getDialogOptions();
        opt.width = 650;
        opt.modal = true;
        return opt;
    }
}
}